export default {
    verb: 'doingCreate',
    namespace: 'security',
    relation: 'profile',
    type: 'login',
    prerequisites: [],
    description: 'Authenticate a user',
    //this is the actual logic:
    logic: login
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function login() {
    throw new Error('Non-Auth0 code was not deleted correctly');
}
